import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './translationBase'

Vue.use(VueI18n);

let i18n = new VueI18n({
    locale: 'et', // set locale
    messages
})

  export default i18n;